import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-[#2C2C2C] text-white">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-6 py-16">
        {/* Top Section */}
        <div className="flex flex-col md:flex-row justify-between items-start mb-12">
          <div className="mb-6 md:mb-0">
            <img
              src="https://public.readdy.ai/ai/img_res/3b2ebd6b-4b18-41e2-9b74-955a6cad8777.png"
              alt="クニエ合同会社"
              className="h-12 w-auto object-contain brightness-0 invert"
            />
          </div>
          <div className="max-w-md">
            <p className="text-sm text-gray-300 leading-relaxed">
              誠実な事業運営を通じて、お客様の成長を支援いたします。
            </p>
          </div>
        </div>

        {/* Navigation Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12">
          {/* Business Column */}
          <div>
            <h3 className="text-lg font-bold mb-4">事業内容</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/business" className="text-sm text-gray-300 hover:text-white transition-colors cursor-pointer">
                  広告業
                </Link>
              </li>
              <li>
                <Link to="/business" className="text-sm text-gray-300 hover:text-white transition-colors cursor-pointer">
                  Web関連事業
                </Link>
              </li>
              <li>
                <Link to="/business" className="text-sm text-gray-300 hover:text-white transition-colors cursor-pointer">
                  音楽制作
                </Link>
              </li>
              <li>
                <Link to="/business" className="text-sm text-gray-300 hover:text-white transition-colors cursor-pointer">
                  コンサルティング
                </Link>
              </li>
              <li>
                <Link to="/business" className="text-sm text-gray-300 hover:text-white transition-colors cursor-pointer">
                  イベント運営
                </Link>
              </li>
            </ul>
          </div>

          {/* Company Column */}
          <div>
            <h3 className="text-lg font-bold mb-4">会社情報</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/company" className="text-sm text-gray-300 hover:text-white transition-colors cursor-pointer">
                  会社概要
                </Link>
              </li>
              <li>
                <Link to="/company" className="text-sm text-gray-300 hover:text-white transition-colors cursor-pointer">
                  事業の目的
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm text-gray-300 hover:text-white transition-colors cursor-pointer">
                  お問い合わせ
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Column */}
          <div>
            <h3 className="text-lg font-bold mb-4">お問い合わせ</h3>
            <p className="text-sm text-gray-300 leading-relaxed">
              事業内容に関するご質問やご相談は、お問い合わせフォームよりご連絡ください。
            </p>
          </div>

          {/* Copyright Column */}
          <div className="text-right">
            <p className="text-lg font-serif mb-2">© 2025 クニエ合同会社</p>
            <p className="text-sm text-gray-300 font-serif">All rights reserved</p>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="flex items-center gap-3">
              <img
                src="https://public.readdy.ai/ai/img_res/3b2ebd6b-4b18-41e2-9b74-955a6cad8777.png"
                alt="クニエ合同会社"
                className="h-8 w-auto object-contain brightness-0 invert"
              />
            </div>
            <p className="text-lg font-serif text-center">
              健全な事業運営を通じて、社会に貢献いたします。
            </p>
            <div>
              <a
                href="https://readdy.ai/?ref=logo"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer"
              >
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
